
<script>

import gsap from "gsap"
import Line from './Line.js'
import setG from './Base.js'

export default {

  name: 'Base',
  props: ['channel', 'indice'],
  data: ()=>({
    c: null,
    ctx: null,
    lines: null,
    tau: null,
    scale: null,
    base: null,
    config: null,
    space: 3

  }),

  mounted() {
    this.config = {} 
    const base = _.clone(setG['global'])
    const specs = _.clone(setG[this.channel])
    _.forIn(base, (val, name)=>{ this.config[name] = val })
    _.forIn(specs, (val, name)=>{ this.config[name] = val })
    this.config['radius'] = 100 - (this.space*this.indice)
    // this.config['lengthMove'] = 2.2*this.indice * (Math.random() * ( 1.00 - 0.5 ) + 0.5)
    // this.config['offset'] = 5.4*this.indice * (Math.random() * ( 1.00 - 0.5 ) + 0.5)

    // this.config['lengthMove'] = Math.random() * ( 2.00 - 1.00 ) + 1.00
    this.config['offset'] = Math.random() * ( 8.00 - 1.00 ) + 1.00
    // this.config['length'] = Math.random() * ( 2.00 - 1.00 ) + 1.00

    this.init()
  },

  methods:{

    /*=============================================
    Utility
    =============================================*/

    rand( min, max ) {
      return Math.random() * ( max - min ) + min
    },
    normalizeFromCenter( val, max ) {
      return ( max - Math.abs( max - ( val * 2 ) ) ) / max
    },

    /*=============================================
    Scene
    =============================================*/

    init() {

      this.c = this.$parent.c
      this.ctx = this.$parent.ctx
      this.lines = []
      this.tau = Math.PI * 2
      this.reset()
    },

    reset() {
      
      this.w = innerWidth
      this.h = innerHeight
      this.lines.length = 0

      for( let i = 0; i < this.config.lineCount; i++ ) {

        const ln = new Line({
          angle: i / this.config.lineCount * this.tau - Math.PI / 2,
          length: this.config.length,
          lengthMove: this.config.lengthMove,
          radius: this.config.radius,
          offset: ( this.normalizeFromCenter( i, this.config.lineCount ) * this.config.offset ) / this.config.speed,
          hue: this.config.hueBase + this.rand( -this.config.hueRange / 2, this.config.hueRange / 2 )
        })

        this.lines.push(ln)
      }

      this.$parent.isReady()

    },

    step() {
      let i = this.lines.length
      while( i-- ) { this.lines[ i ].step(this.config) }
    },

    draw() {
      let i = this.lines.length
      while( i-- ) { this.lines[ i ].draw(this.ctx) }
    },

    // loop() {
    //   requestAnimationFrame( this.loop )
    //   this.step()
    //   this.draw()
    // },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Base
  position fixed
  top 0
  width 100vw
  height 100%
  overflow hidden  

  canvas 
    display block
    height 100vh
    border none

  body .dg .c .slider-fg 
    background #666 

  .slider-fg 
    transition width 150ms 

  .slider:active .slider-fg 
    transition-duration 0ms

</style>


